import React from "react";

import Login from "../pages/login";
import CustomerInfo from "../pages/customer_info";
import PasswordUpdate from "../pages/password_update";
import CustomerHistories from "../pages/customer_histories";
import CustomerDeleteMemo from "../pages/customer_delete_memo";

const LOGIN = <Login />;
const CUSTOMER_INFO = <CustomerInfo />;
const PASSWORD_UPDATE = <PasswordUpdate />;
const CUSTOMER_HISTORIES = <CustomerHistories />;
const CUSTOMER_DELETE_MEMO = <CustomerDeleteMemo />;

export {
  LOGIN,
  CUSTOMER_INFO,
  PASSWORD_UPDATE,
  CUSTOMER_HISTORIES,
  CUSTOMER_DELETE_MEMO,
};
